<!--
 * @description:
 * @author: Jason Wong
 * @since: 2022-10-26 11:57:16
-->
<template>
  <div
    class="component__glossary--extract-term-list flex-expend table-like-container border"
  >
    <div class="partition-area left" style="right: 40%">
      <div class="partition-area__header">
        <span class="span__head" style="width: 48px; text-align: center">
          <div style="width: 24px">
            <el-checkbox @change="handleBatchCheckboxChanged"></el-checkbox>
          </div>
        </span>
        <span class="span__head" style="width: 48px">&nbsp;</span>
        <span class="span__head flex-expend">{{
          `原文（${filterDictText(predefinedInfo.languages,project.srcLang) || "-"}）`
        }}</span>
        <div class="span__head flex-expend">
          <span>{{ `译文（${filterDictText(predefinedInfo.languages,project.tgtLang) || "-"}）` }}</span>
          <el-popover trigger="hover">
            <span>同一词条添加多个术语请用“,”（英文）隔开，最大支持20个。</span>
            <span slot="reference" class="color-primary cursor__default"
              >&nbsp;多条术语?</span
            >
          </el-popover>
        </div>
        <span class="span__head" style="width: 96px">{{ `词长（原文）` }}</span>
        <span class="span__head" style="width: 120px"
          >{{ `词频（原文）` }}
          <ve-sort-button
            style="margin-left: -10px"
            v-model="frequencySortRule"
          ></ve-sort-button>
        </span>
        <span v-if="false">类型</span>
      </div>
      <el-scrollbar ref="rowListContainer" class="partition-area__body">
        <el-table
          size="mini"
          ref="sentencesTable"
          :show-header="false"
          highlight-current-row
          :data="filterTerms"
          @current-change="currentSentenceChanged"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="48"></el-table-column>
          <el-table-column type="index" width="48"></el-table-column>
          <el-table-column label="原文（中文）" prop="src">
            <template slot-scope="scope">
              <span class="font-14">{{ scope.row.src }}</span>
            </template>
          </el-table-column>
          <el-table-column label="译文（英文）">
            <template slot-scope="scope">
              <div
                :class="[
                  'tgt-container',
                  'relative',
                  !validateResultList[scope.row.id].success
                    ? 'with-validate-error'
                    : null,
                ]"
                :title="
                  !validateResultList[scope.row.id].success
                    ? validateResultList[scope.row.id].error
                    : null
                "
              >
                <ve-text-editor
                  v-model="scope.row.tgt"
                  @change="handleTgtChanged(scope.row, $event)"
                ></ve-text-editor>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="96"
            label="词长（原文）"
            prop="srcLength"
          ></el-table-column>
          <el-table-column
            width="120"
            label="词频（原文）"
            prop="frequency"
            sortable
          ></el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
    <div class="partition-area right" style="width: 40%">
      <div class="partition-area__header" style="line-height: 29px">
        <span class="to-right">术语和原句</span>
      </div>
      <div
        class="partition-area__body flow-auto"
        style="background-color: #fef6ed"
      >
        <el-alert
          class="empty-message"
          style="width: fit-content"
          v-if="!translationDetails || translationDetails.length <= 0"
          type="warning"
          show-icon
          :closable="false"
          title="暂无数据"
        ></el-alert>
        <template v-else>
          <el-card header="自动提取的术语" class="m-12 translation__original">
            <el-table size="small" :data="snapshotData" :show-header="false">
              <el-table-column prop="src"></el-table-column>
              <el-table-column prop="tgt"></el-table-column>
            </el-table>
          </el-card>
          <TranslationDetail
            v-for="detail in translationDetails"
            class="block__translation-detail"
            :key="detail.id"
            :detail="detail"
          >
          </TranslationDetail>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { isBlank } from "@/utils/String";
import TranslationDetail from "./translationDetail.vue";
import { checkTermTgtIsValid } from "../data";
import {filterDictText} from "@/utils/dict/JDictSelectUtil";
import {getDictOptions} from "@/utils/dict";


export default {
  props: {
    project: {},
    lines: [],
    terms: [],
    readonly: {
      type: Boolean,
      default: false,
    },
    filter: Object,
  },
  components: {
    TranslationDetail,
  },
  data() {
    return {
      currentTerm: null,
      selectedTerms: [],
      translationDetails: null,
      changedTerms: new Set(),
      deletedTerms: new Set(),

      frequencySortRule: "desc",
      validateResultList: {},

      predefinedInfo: {
        languages: []
      }
    };
  },
  methods: {
    filterDictText,
    _getTgtOfRow(row, filedName = "translations") {
      let termTextSet = (row[filedName] || []).reduce((pre, cur) => {
        pre.add(cur.term.trim());
        return pre;
      }, new Set());
      let result = "";
      termTextSet.forEach((v) => {
        if (result.length > 0) result += ", ";
        result += v;
      });
      return result;
    },
    _addExtraField(rows) {
      (rows || []).$$each((row) => {
        Vue.set(row, "tgt", this._getTgtOfRow(row));
        Vue.set(
          row,
          "originalTgt",
          this._getTgtOfRow(row, "translationSnapshots")
        );
      });
    },
    autoSelectFirstRow() {
      this.$nextTick(() => {
        if (
          !!this.filterTerms &&
          this.filterTerms.length > 0 &&
          (!!this.currentTerm || this.filterTerms.indexOf(this.currentTerm) < 0)
        ) {
          this.$refs.sentencesTable.setCurrentRow(this.filterTerms[0]);
        }
      });
    },
    handleBatchCheckboxChanged(newValue) {
      this.$refs.sentencesTable.clearSelection();
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.sentencesTable.toggleAllSelection();
        });
      }
    },
    currentSentenceChanged(row) {
      this.currentTerm = row;
    },
    handleSelectionChange(selection) {
      this.selectedTerms = selection || [];
    },
    handleTgtChanged(row, { newValue, oldValue }) {
      this.recordRowChanged(row);
      this.validateTerm(row);
    },
    recordRowChanged(row) {
      if (this.readonly) return;
      this.changedTerms.add(row);
    },
    getChangedTerms() {
      console.log("#-# getChangedTerms", this.changedTerms, this.deletedTerms);
      return {
        edited: [...this.changedTerms.values()],
        deleted: [...this.deletedTerms.values()],
      };
    },
    resetChangedRows() {
      console.log("#-# reset rows");
      this.changedTerms = new Set();
      this.deletedTerms = new Set();
    },
    markTermsEdited(terms) {
      for (const term of terms) {
        this.changedTerms.add(term);
      }
    },
    resetLineValidateResult() {
      console.log("#-# resetLineValidateResult");
      const validateResultList = {};
      (this.terms || []).map((t) => {
        validateResultList[t.id] = {
          success: true,
          error: null,
        };
      });
      this.validateResultList = validateResultList;
    },
    validateTerm(term) {
      const pos = (this.terms || []).indexOf(term);
      if (pos < 0) return;
      const [success, error] = checkTermTgtIsValid(term);
      this.validateResultList[term.id] = { success, error };
      return this.validateResultList[term.id];
    },
    validate() {
      let isAllTermValid = true;
      (this.terms || []).$$each((term) => {
        const res = this.validateTerm(term);
        if (!res.success) {
          isAllTermValid = false;
        }
      });
      return isAllTermValid;
    },
    getSortRule() {
      return this.frequencySortRule;
    },
    getSelectedTerms() {
      return this.selectedTerms;
    },
    deleteSingleTerm(term) {
      console.log("#-# handleClickDelete", term);
      const pos = this.terms.indexOf(term);
      console.log("#-# term pos:", pos);
      if (pos < 0) return;

      this.terms.splice(pos, 1);
      this.deletedTerms.add(term);
      this.changedTerms.delete(term);
    },
    deleteSelectedTerms() {
      this.selectedTerms.forEach((t) => {
        this.deleteSingleTerm(t);
      });
    },
    isListDescending() {
      return this.frequencySortRule == "desc";
    },
    async getLangs() {
      try {
        this.predefinedInfo.languages = await getDictOptions("language");
      } catch (error) {
        this.$$error(error);
      }
    },
  },
  watch: {
    terms: {
      handler(newValue, oldValue) {
        console.log("#-# terms watch", newValue === oldValue);
        if (newValue !== oldValue) {
          if (newValue != null) {
            this._addExtraField(newValue);
          }

          this.resetLineValidateResult();
          this.resetChangedRows();
        }
      },
    },
    currentTerm: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.translationDetails = [];
        } else {
          if (this.extractType == "double") {
            this.translationDetails = (newValue.translationSnapshots || []).map(
              (t) => {
                return {
                  line: this.lines.$$first((l) => t.lineId === l.id),
                  src: newValue.originalSrc,
                  translation: t,
                };
              }
            );
          } else {
            this.translationDetails = (this.lines || [])
              .filter((l) => l.src.indexOf(newValue.originalSrc) > -1)
              .map((l) => ({ src: newValue.originalSrc, line: l }));
          }
        }
      },
    },
    filterTerms(newValue) {
      if (!!newValue && newValue.length > 0) {
        this.autoSelectFirstRow();
      }
    },
  },
  computed: {
    filterTerms() {
      console.log("#-# filter");
      if (!this.filter || !this.terms) return [];
      const flr = this.filter || {};
      let result = this.terms || [];
      if (flr.frequency != null) {
        result = result.filter((r) => r.frequency >= flr.frequency);
      }

      if (flr.srcMinLength != null && flr.srcMaxLength != null) {
        result = result.filter(
          (r) =>
            r.srcLength >= flr.srcMinLength && r.srcLength <= flr.srcMaxLength
        );
      }
      if (flr.tgtMinLength != null && flr.tgtMaxLength != null) {
        result = result.filter((r) => {
          return (r.translations || [{ length: 0 }]).$$any(
            (t) => t.length >= flr.tgtMinLength && t.length <= flr.tgtMaxLength
          );
        });
      }

      if (!isBlank(flr.src)) {
        const srcLowCase = flr.src.trim();
        result = result.filter((r) => r.src.indexOf(srcLowCase) > -1);
      }
      if (!isBlank(flr.tgt)) {
        if (this.extractType == "double") {
          const tgtText = flr.tgt.trim();
          result = result.filter((r) =>
            (r.translations || [{ length: 0 }]).$$any(
              (t) => t.term.indexOf(tgtText) > -1
            )
          );
        } else {
          result = result.filter(
            (r) => r.tgt != null && r.tgt.indexOf(tgtText) > -1
          );
        }
      }
      if (flr.onlySelectedShown) {
        result = result.filter((r) => r.selected);
      }

      result.sort((l, r) => {
        return l.frequency > r.frequency
          ? this.frequencySortRule == "asc"
            ? 1
            : -1
          : l.frequency == r.frequency
          ? 0
          : this.frequencySortRule == "asc"
          ? -1
          : 1;
      });
      return result;
    },
    snapshotData() {
      if (!this.currentTerm) {
        return [];
      } else {
        return [
          {
            src: this.currentTerm.originalSrc,
            tgt: this.currentTerm.originalTgt,
          },
        ];
      }
    },
    extractType() {
      return (this.project || {}).type == 1 ? "double" : "single";
    },
  },
  created() {
    this.resetLineValidateResult();
    console.log(">>>>get langs");
    this.getLangs();
  },
  mounted() {
    console.log("#-# extract term list mounted!");
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/postil.scss";
.component__glossary--extract-term-list {
  .span__head {
    margin: 0;
    padding: 0 10px;
  }

  .block__translation-detail {
    margin: 12px;
    &.el-card {
      .el-card__body {
        padding: 12px;
      }
    }
  }

  .translation__original.el-card {
    .el-card__header {
      font-size: 14px;
      padding: 12px;
    }
    .el-card__body {
      padding: 0;
    }
  }

  .tgt-container {
    border: 1px solid transparent;

    &.with-validate-error {
      border: 1px solid #f56c6c;
    }
  }
}
</style>
